import {
  Button,
  Col,
  DatePicker, Pagination,
  Popover,
  Row, Skeleton, Table
} from "antd";
import { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import { MdTune } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SlotsModal from "../../modals/SlotsModal";
import { Get } from "../../config/api/get";
import { ADMIN, UPLOADS_URL } from "../../config/constants/api";
import moment from "moment";
import { IoIosArrowRoundBack } from "react-icons/io";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";


const DriverManagement = () => {
  dayjs.extend(timezone);
  dayjs.extend(utc);
  const token = useSelector((state) => state.user.userToken);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState(null);
  // const [type, setType] = useState("ALL");
  const [slotsModal, setSlotsModal] = useState(false);
  const navigate = useNavigate();
  // const [loads, setLoads] = useState(null);
  const [open, setOpen] = useState(false);
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });

  const [filter, setFilter] = useState({
    status: null,
    type: null,
    keyword: "",
    from: null,
    to: null,
  });
  const getUsers = (pageNumber, pageSize, from, to) => {
    setLoading(true);
    Get(ADMIN.getChauffeurRequests, token, {
      from,
      to,
      status:'PENDING',
      page: pageNumber
        ? pageNumber.toString()
        : paginationConfig.pageNumber.toString(),
      limit: pageSize ? pageSize.toString() : paginationConfig.limit.toString(),
    })
      .then((response) => {
        if (response?.data?.docs) {
          setUsers(response?.data?.docs);
          setPaginationConfig({
            pageNumber: response?.data?.page,
            limit: response?.data?.limit,
            totalDocs: response?.data?.totalDocs,
            totalPages: response?.data?.totalPages,
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("Error Fetching Loads", err);
        setLoading(false);
      });
  };
  useEffect(() => {
    getUsers();
    // eslint-disable-next-line
  }, []);
  // const capitalizeFirstLetter = (str) => {
  //   return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  // };

  // const handlePageChange = (pageNumber) => {
  //   setPaginationConfig({
  //     ...paginationConfig,
  //     pageNumber: pageNumber,
  //   });
  //   getUsers(pageNumber, paginationConfig.limit);
  // };



  // const handleStatusChange = (value) => {
  //   setFilter({
  //     ...filter,
  //     status: value,
  //   });
  // };

  // const handleTypeChange = (value) => {
  //   setFilter({
  //     ...filter,
  //     type: value,
  //   });
  // };

  const resetFilter = () => {
    setFilter({
      status: null,
      keyword: "",
      from: null,
      to: null,
    });
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handleFrom = (date) => {
    setFilter({
      ...filter,
      from: date,
    });
  };

  const handleTo = (date) => {
    setFilter({
      ...filter,
      to: date,
    });
  };
  const data = {
    status: filter.status,
    keyword: filter.keyword,
    from: filter.from,
    to: filter.to,
  };
  const handleApply = () => {
    let from;
    let to;
    if (data.from) {
      from = moment(filter?.from?.$d).format("YYYY-MM-DD");
    }
    if (data.to) {
      to = moment(filter?.to?.$d).format("YYYY-MM-DD");
    }
    if (from || to ) {
      getUsers(
        paginationConfig.pageNumber,
        paginationConfig.limit,
        from,
        to,
      );
    } else {
      return;
    }
  };
  const handleClear = () => {
    resetFilter();
    getUsers();
  };

  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const message = `Showing records ${endIndex} of ${paginationConfig.totalDocs}`;

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <button type="button" className="pagination-link">
          Previous
        </button>
      );
    }
    if (type === "next") {
      return (
        <button type="button" className="pagination-link">
          Next
        </button>
      );
    }

    return originalElement;
  };

  const filterContent = (
    <div className="filterDropdown">
      <div>
        <p
          className="mainLabel"
          style={{ padding: "10px", fontSize: "18px", fontWeight: "bold" }}
        >
          Filter
        </p>
      </div>
      <hr style={{ marginBottom: 10 }} />

      <div className="filterDropdownBody">
        <p className="mainLabel">From:</p>
        <DatePicker
          className="mainInput filterInput web-input"
          value={filter.from}
          onChange={(e) => handleFrom(e)}
          style={{ width: "100%" }}
        />
        <p className="mainLabel">To:</p>
        <DatePicker
          className="mainInput filterInput web-input"
          value={filter.to}
          onChange={(e) => handleTo(e)}
          style={{ width: "100%" }}
        />

        {/* <p className="mainLabel"> Status:</p> */}

        {/* <Select
          size={"large"}
          className="filterSelectBox"
          placeholder="Select Status"
          value={filter.status}
          onChange={(e) => handleStatusChange(e)}
          style={{
            width: "100%",
            marginBottom: "10px",
            textAlign: "left",
          }}
          options={[
            { value: "UPCOMING", label: "Upcoming" },
            { value: "ONGOING", label: "Ongoing" },
            { value: "COMPLETED", label: "Completed" },
          ]}
        /> */}

        <Button
          type=""
          block
          size={"large"}
          style={{ marginBottom: "10px" }}
          className="web-btn"
          //   onClick={() => getUsers()}
          onClick={handleApply}
        >
          Apply
        </Button>
        <Button
          type=""
          block
          size={"large"}
          className="web-btn"
          onClick={handleClear}
        >
          Clear All
        </Button>
      </div>
    </div>
  );

  

  const columns = [
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          s no
        </p>
      ),
      dataIndex: "key",
      key: "key",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {(index < 10 && "0") + (index + 1)}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          image
        </p>
      ),
      dataIndex: ["chauffeur","image"],
      key: ["chauffeur","image"],
      render: (value, item, index) => (
        <div className="flex flex-col items-center justify-center">
            <img
            src={UPLOADS_URL + value}
            alt="profile"
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "100%",
              objectFit: "cover",
              objectPosition: "center",
            }}
          />
          {/* <div className="flex justify-center items-center p-[2px] rounded-full bg-[#1A1A1A] ml-[-12px] mt-[-12px]">
            <FaStar size={14} className="text-[#EDCA24]" />
            <p className="font-euclid text-xs text-white mx-1">0</p>
            <PiWechatLogoFill size={14} className="text-[#EDCA24]" />
          </div> */}
        </div>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Name
        </p>
      ),
      dataIndex: "name",
      key: "name",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {item?.chauffeur?.firstName} {item?.chauffeur?.lastName}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Email
        </p>
      ),
      dataIndex: "email",
      key: "email",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {item?.chauffeur?.email}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Reuquested ON
        </p>
      ),
      dataIndex: "createdAt",
      key: "createdAt",
      render: (item) => <span>{dayjs.tz(item, "UTC").format("M/D/YYYY")}</span>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (item) => (
        <>
          {item === "PENDING" ? (
            <span style={{ color: "#DD9F00" }}>{item}</span>
          ) : item === "INACTIVE" ? (
            <span style={{ color: "#ff0000" }}>{item}</span>
          ) : item === "ACTIVE" ? (
            <span style={{ color: "#00D640" }}>{item}</span>
          ) : (
            <span>{item}</span>
          )}
        </>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          action
        </p>
      ),
      dataIndex: "_id",
      key: "_id",
      render: (value, item, index) => (
        <div className="flex justify-center">
          <div className="flex justify-center bg-[#FDE6C3] rounded-[100%] w-fit p-2 mr-1">
            <FaEye
              className="text-[#CD810D] cursor-pointer h-[16px] w-[16px]"
              onClick={() => navigate("/ChauffeurRequestList/" + item._id , {state: {request : item}})} 
            />
          </div>
          {/* <div className="flex justify-center bg-[#9CFEC4] rounded-[100%] w-fit p-2">
              <RiEdit2Fill
                className="text-[#089B44] cursor-pointer h-[16px] w-[16px]"
                onClick={() => navigate("/editDriver/personal/" + item._id)}
              />
            </div> */}
        </div>
      ),
    },
  ];
  return (
    <div>
      <Row justify="center">
        <Col md={23} xs={22}>
          <div className="flex justify-between items-center my-8">
            <div className="flex justify-center items-center">
              <IoIosArrowRoundBack
                onClick={() => navigate(-1)}
                className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px] text-black"
              />
              <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
                Chauffeur Request
              </h3>
            </div>
            <div className="flex max-md:flex-col justify-center items-center">
              {/* <Input
                style={{ width: "250px" }}
                className="mainInput dashInput h-full max-md:order-1"
                placeholder="Search"
                //   onChange={(e) => handleSearch(e.target.value)}
                suffix={
                  <FaSearch
                    style={{
                      color: "#818181",
                      fontSize: 16,
                      cursor: "pointer",
                    }}
                    //   onClick={() =>
                    //     getUsers(1, paginationConfig.limit, filter.keyword)
                    //   }
                  />
                }
                //   onPressEnter={(e) =>
                //     getUsers(1, paginationConfig.limit, filter.keyword)
                //   }
              /> */}
              &emsp;
              <div className="flex justify-center max-md:order-0 max-md:mb-2">
                <Popover
                  content={filterContent}
                  trigger="click"
                  open={open}
                  onOpenChange={handleOpenChange}
                  placement="bottomRight"
                  arrow={false}
                >
                  <Button
                    style={{
                      padding: "4px 11px",
                      height: "auto",
                      borderRadius: "6px",
                      backgroundColor: "white",
                    }}
                  >
                    <MdTune className="max-xl:text-[20px] text-[32px] text-[#767676]" />
                  </Button>
                </Popover>
              </div>
            </div>
          </div>
          {/* <div className="flex justify-start items-center ml-4">
              <button
                className={`uppercase ${
                  type === "ALL" ? "bg-button" : "bg-[#576C7E]"
                } py-3 max-sm:py-1 max-sm:px-1 px-3 xl:px-12 text-white rounded-t-[4px] font-bold text-sm max-2xl:text-[10px] max-sm:text-[8px] max-md:py-2 mr-2 font-euclid`}
                onClick={() => setType("ALL")}
              >
                ALL
              </button>
              <button
                className={`uppercase ${
                  type === "ONLINE" ? "bg-button" : "bg-[#576C7E]"
                } py-3 max-sm:py-1 max-sm:px-1 px-3 xl:px-12 text-white rounded-t-[4px] font-bold text-sm max-2xl:text-[10px] max-sm:text-[8px] max-md:py-2 mr-2 font-euclid`}
                onClick={() => setType("ONLINE")}
              >
                online drivers
              </button>
              <button
                className={`uppercase ${
                  type === "OFFLINE" ? "bg-button" : "bg-[#576C7E]"
                } py-3 max-sm:py-1 max-sm:px-1 px-3 xl:px-12 text-white rounded-t-[4px] font-bold text-sm max-2xl:text-[10px] max-sm:text-[8px] max-md:py-2 mr-2 font-euclid`}
                onClick={() => setType("OFFLINE")}
              >
                offline drivers
              </button>
              <button
                className={`uppercase ${
                  type === "PENDING" ? "bg-button" : "bg-[#576C7E]"
                } py-3 max-sm:py-1 max-sm:px-1 px-3 xl:px-12 text-white rounded-t-[4px] font-bold text-sm max-2xl:text-[10px] max-sm:text-[8px] max-md:py-2 mr-2 font-euclid`}
                onClick={() => setType("PENDING")}
              >
                pending
              </button>
            </div> */}
          <div
            className="bg-white rounded-lg  py-8 mb-8"
            style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
          >
            <Row style={{ overflow: "auto" }} className="px-6">
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Skeleton active />
                  <br />
                </div>
              ) : (
                <Table
                  className="styledTable"
                  dataSource={users}
                  columns={columns}
                  pagination={false}
                />
              )}
            </Row>
            <Row style={{ padding: "10px 20px" }}>
              <Col xs={24} md={12}>
                <p className="font-euclid text-sm text-black">{message}</p>
              </Col>
              <Col
                xs={24}
                md={12}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Pagination
                  className="styledPagination"
                  // onChange={(e) => handlePageChange(e)}
                  current={parseInt(paginationConfig.pageNumber)}
                  pageSize={paginationConfig.limit}
                  total={paginationConfig.totalDocs}
                  itemRender={itemRender}
                />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      {slotsModal && (
        <SlotsModal slotsModal={slotsModal} setSlotsModal={setSlotsModal} />
      )}
    </div>
  );
};

export default DriverManagement;
